import lectures from "../imgs/lectures.png";
import lect_1 from "./lectures/1410_1.pdf";
import lect_2 from "./lectures/1410_2.pdf";
import lect_3 from "./lectures/1410_3.pdf";
import lect_4 from "./lectures/1410_4.pdf";
import lect_5 from "./lectures/1410_5.pdf";
import lect_6 from "./lectures/1410_6.pdf";
import lect_7 from "./lectures/1410_7.pdf";
import lect_8 from "./lectures/1410_8.pdf";
import lect_10 from "./lectures/1410_10.pdf";
import lect_11 from "./lectures/1410_11.pdf";
import lect_12 from "./lectures/1410_12.pdf";
import lect_13 from "./lectures/1410_13.pdf";
import lect_14 from "./lectures/1410_14.pdf";
import lect_15 from "./lectures/1410_15.pdf";
import lect_16 from "./lectures/1410_16.pdf";
import lect_17 from "./lectures/1410_17.pdf";
import lect_18 from "./lectures/1410_18.pdf";
import lect_19 from "./lectures/1410_19.pdf";
import lect_20 from "./lectures/1410_20.pdf";
import lect_21 from "./lectures/1410_21.pdf";
import lect_22 from "./lectures/1410_22.pdf";
import lect_23 from "./lectures/1410_23.pdf";

function LecturesPage() {
  return (
    <div className="lectures-page">
      <div className="lectures">
        <img className="lectures-img" src={lectures} alt="Lecture Header"></img>
      </div>
      <div
        className="lectures-desc"
        style={{ color: "ghostwhite", fontSize: "25px", textAlign: "left", width: "80vw", marginLeft: "10vw" }}
      >
        <p>
          In person lectures take place{" "}
          <b>Tuesdays and Thursdays from 9:00am to 10:20pm Eastern Time in List Art Center 120.</b> Lectures slides will
          be posted before each lecture. Recordings will be available for remote students and review, which are
          available on{" "}
          <a
            href="https://brown.hosted.panopto.com/Panopto/Pages/Sessions/List.aspx#folderID=%22a4085fcd-12fc-4f8f-86db-b068010fc2db%22"
            target="_blank"
          >
            Panopto
          </a>
          . The supplementary textbook for this course is{" "}
          <i>Artificial Intelligence: A Modern Approach (Pearson Series in Artifical Intelligence)</i>
        </p>
      </div>
      <div
        className="lectures-desc"
        style={{ color: "ghostwhite", fontSize: "25px", textAlign: "center", width: "80vw", marginLeft: "10vw" }}
      >
        <p>
          We will have an in-class midterm on October 10, and a final exam on December 19 at 9am during the final
          examination period.
        </p>
      </div>
      <div className="table-wrapper">
        <table className="lectures-table">
          <tr>
            <th width="10%">Date</th>
            <th width="75%">Topic</th>
            <th width="10%">Slides</th>
            <th width="5%">Recordings</th>
            <th width="10%">Post-Lecture Quiz</th>
          </tr>
          <tr>
            <td>9/7</td>
            <td>Introduction; Agents and Agenthood</td>
            <td>
              <a href={lect_1} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=56fb8aec-a176-452a-80cf-b0680110325c"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>9/12</td>
            <td>Search</td>
            <td>
              <a href={lect_2} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=2a30eba5-e5d0-4908-893a-b068011032a3"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/ETTgHFHEMey5mvXr7" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>9/14</td>
            <td>Game Theory</td>
            <td>
              <a href={lect_3} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=fb451f70-fa3a-4a6f-ba5f-b068011032bd"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/tnt9TLZE3tYNRimG8" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>9/19</td>
            <td>Adversarial Search</td>
            <td>
              <a href={lect_4} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=89e4bd78-8c1b-41e6-b509-b068011032d2"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/bJaUdyd2sAfdsL9T6" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>9/21</td>
            <td>Knowledge Representation and Reasoning (Logic)</td>
            <td>
              <a href={lect_5} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=9243c258-44e6-4048-af6b-b068011032e8"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/RkNGGWZinV4t2Ace7" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>9/26</td>
            <td>Uncertain Knowledge and Bayes' Rule</td>
            <td>
              <a href={lect_6} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=b1d03a8a-2de6-427c-86bb-b068011032fd"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/j1DZJZyX9F7YiGVm9" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>9/28</td>
            <td>Bayesian Networks</td>
            <td>
              <a href={lect_7} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=3c262a63-5829-4240-8108-b06801103320"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/4oaiAP3347qkhryH7" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>10/3</td>
            <td>Hidden Markov Models</td>
            <td>
              <a href={lect_8} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=6694538f-2a5a-4d18-bfe3-b06801103343"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/QStE1nPRQPtADXcJ9" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>10/5</td>
            <td>Midterm Review</td>
            <td>
              <a
                href="https://docs.google.com/presentation/d/1STlMhiNBvdSBk_JZo0pZoqlax1It_mldM4tw8uWSIkY/edit?usp=sharing"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=a1bf6fea-68cd-47e3-b229-b0680110335d"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <div>N/A</div>
            </td>
          </tr>
          <tr>
            <td>10/10</td>
            <td>Midterm</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>10/12</td>
            <td>Classical Planning</td>
            <td>
              <a href={lect_10} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=29fb9303-c827-4d09-bd66-af0800fdb0fe"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/Wy1rtHjXWvK2YKcc9" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>10/17</td>
            <td>Probabilistic Planning</td>
            <td>
              <a href={lect_11} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=cd55636d-2960-46d8-8d23-b068011033b1"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/hjbJ4r37Z5PrqjEXA" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>10/19</td>
            <td>Reinforcement Learning</td>
            <td>
              <a href={lect_12} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=f094b1ac-cd9d-4c31-9de5-b068011033ce"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/6VUp4eztDveB5eU77" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>10/24</td>
            <td>Reinforcement Learning II</td>
            <td>
              <a href={lect_13} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=4ae1efe2-161c-4427-81ad-b068011033e8"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/7nMqkLu6LLdn3BoY6" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>10/26</td>
            <td>Supervised Learning</td>
            <td>
              <a href={lect_14} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=f39cf511-ab62-44cc-a713-b06801103403"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/rN4VAnGhkN9BYovi8" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>10/31</td>
            <td>Supervised Learning II</td>
            <td>
              <a href={lect_15} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=f8c2d3a5-3c50-4244-805c-b0680110341f"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/bFjPDAzJkzuysuTD8" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>11/2</td>
            <td>Unsupervised Learning</td>
            <td>
              <a href={lect_16} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=c36a2594-2159-4f40-94e3-b0680110343e"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/saC66LokJrv3EZmc9" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr className="no-class">
            <td>11/7</td>
            <td>NO CLASS (election day)</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>11/9</td>
            <td>Unsupervised Learning II</td>
            <td>
              <a href={lect_17} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=5ca80d2e-7e7f-4ca1-a349-b06801103477"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/JQU7aw1MhcnQghBR8" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>11/14</td>
            <td>Robotics</td>
            <td>
              <a href={lect_18} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=fecd2588-ba95-45e2-9da3-b0680110349c"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/b4MbqpW4FjYV3UDW8" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>11/16</td>
            <td>Natural Language Processing</td>
            <td>
              <a href={lect_19} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=70b53ed8-858a-4bd7-a257-b068011034b8"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/taCQjdCpCSabQN5P9" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr className="no-class">
            <td>11/21</td>
            <td>NO CLASS (Thanksgiving)</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="no-class">
            <td>11/23</td>
            <td>NO CLASS (Thanksgiving)</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>11/28</td>
            <td>Computer Vision</td>
            <td>
              <a href={lect_20} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=35dd82c6-dade-490f-a1b7-b0680110350a"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/CixgLejgwrZtBN738" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>11/30</td>
            <td>Philosophy of A.I.</td>
            <td>
              <a href={lect_21} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=37cf4811-74d5-4a4f-b09d-b06801103525"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/sVXMWD5LrqUp4M6F6" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>12/5</td>
            <td>Social and Ethical Issues</td>
            <td>
              <a href={lect_22} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=b218764f-99ec-4c4e-bd3c-b0680110353d"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/pwrWr91Xe8bcQBca7" target="_blank">
                <div>link</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>12/7</td>
            <td>Ethical Dillemas in A.I.</td>
            <td>
              <a href={lect_23} target="_blank">
                <div>pdf</div>
              </a>
            </td>
            <td>
              <a
                href="https://brown.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=a7f0dc61-e508-4819-90c0-b06801103555"
                target="_blank"
              >
                <div>link</div>
              </a>
            </td>
            <td>
              <a href="https://forms.gle/ozbMh4vTa8CZLiCz6" target="_blank">
                <div>link</div>
              </a> 
            </td>
          </tr>
          <tr>
            <td>12/12</td>
            <td>Final Review</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
    </div>
  );
}

export default LecturesPage;
